import { chain, reverse, noop, remove, get, includes } from "lodash"

const totalFilter = ({ id }) => id === "total" || id.indexOf("_total") !== -1
const segmentFilter = ({ id }) => id === "segment"

export function sortData(data, groupOrder = {}) {
  const copy = [...data]
  const total = remove(copy, totalFilter)
  const segment = remove(copy, segmentFilter)

  const valueGetter = !groupOrder.order || includes(["descAbs", "ascAbs"], groupOrder.order) ? (v) => Math.abs(get(v, `${groupOrder.by}`)) : (v) => get(v, `${groupOrder.by}`)
  let sortedData = chain(copy)
    .sortBy(valueGetter)
    .value()
  if (!groupOrder.order || groupOrder.order.substr(0, 3) !== "asc") {
    sortedData = reverse(sortedData)
  }

  return [
    ...total,
    ...segment,
    ...sortedData,
  ]
}

export function changeGroupSort(groupSort = noop, order) {
  switch (order) {
    case "desc":
      groupSort("asc")
      break
    case "asc":
      groupSort("descAbs")
      break
    case "descAbs":
      groupSort("ascAbs")
      break
    case "ascAbs":
    default:
      groupSort("desc")
      break
  }
}

export function getTitle(sort, label) {
  if (!sort) { return label }
  switch (sort) {
    case "asc":
      return `${label} sorted negative to positive`
    case "desc":
      return `${label} sorted positive to negative`
    case "ascAbs":
      return `${label} sorted low to high magnitude`
    case "descAbs":
      return `${label} sorted high to low magnitude`
  }
  return label
}

export function makeGroupSort(order) {
  return [(group) => {
    switch (order.by) {
      case "name":
        return group.name
      case "equity":
        return order.abs ? Math.abs(group.totalPercentEquity) : group.totalPercentEquity
      default:
        return order.abs ? Math.abs(group.value) : group.value
    }
  },
  order.dir]
}
